import { render, staticRenderFns } from "./VoteUserComponent.vue?vue&type=template&id=73690bce&scoped=true&"
import script from "./VoteUserComponent.vue?vue&type=script&lang=js&"
export * from "./VoteUserComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73690bce",
  null
  
)

export default component.exports